import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../services/user-service';
import { get } from 'lodash';
import { CMS_ROUTES } from '../../_shared/cms-routes.constant';

@Component({
  selector: 'app-cms-layout',
  templateUrl: './cms-layout.component.html',
  styleUrls: ['./cms-layout.component.scss'],
  standalone: false
})
export class CmsLayoutComponent implements OnInit {
  @Input() cmsTitle: string = '';
  cmsRoutes: any[] = [];

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.initCMSRoutes();
  }

  /**
   * Initializes CMS routes based on user role.
   * Filters routes within each group and removes groups with no accessible routes.
   */
  private initCMSRoutes() {
    const userRole = get(this.userService.user, 'role');
    this.cmsRoutes = CMS_ROUTES.map((item) => {
      const { groupTitle, groupId, groupHref, routes } = item;
      return {
        groupTitle,
        groupId,
        groupHref,
        routes: routes.filter(route => route.roles.includes(userRole)),
      };
    }).filter(group => group.routes.length > 0);
  }
}

